import Divider from '@mui/material/Divider';
import InfoIcon from '@mui/icons-material/InfoOutlined';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import config from '../../config/config';
import { formatProviderName } from '../../helpers/providers';
import { formatDate } from '../../helpers/dates';
import LeadStatus from './LeadStatus';

const LeadSummaryInfo = ({ lead }) => {
  return (
    <Stack spacing={1} marginTop={0} style={{marginTop: 0}}>
      <Stack direction='row' spacing={1} alignItems='center' marginTop={0}>
        <InfoIcon style={{fontSize: '1.1rem'}} />
        <Typography variant='h3' marginTop={0}>Summary</Typography>
      </Stack>
      <Divider />
      <Stack direction='row' alignItems='center' spacing={1}>
        <Typography variant='body1'>
          <strong style={{color: config().colors.muted}}>Status:</strong>
        </Typography>
        <LeadStatus lead={lead} />
      </Stack>
      <Typography variant='body1'>
        <strong style={{color: config().colors.muted}}>Name:</strong> {lead.contact_first_name} {lead.contact_last_name}
      </Typography>
      <Typography variant='body1'>
        <strong style={{color: config().colors.muted}}>Email:</strong> {lead.contact_email}
      </Typography>
      <Typography variant='body1'>
        <strong style={{color: config().colors.muted}}>Phone:</strong> {lead.contact_phone}
      </Typography>
      <Divider />
      <Typography variant='body1'>
        <strong style={{color: config().colors.muted}}>Created By:</strong> {formatProviderName(lead.creator) || 'Website Signup'}
      </Typography>
      <Typography variant='body1'>
        <strong style={{color: config().colors.muted}}>Created At:</strong> {formatDate(lead.date_created)}
      </Typography>
      <Typography variant='body1'>
        <strong style={{color: config().colors.muted}}>Last Updated By:</strong> {formatProviderName(lead.updater) || 'NA'}
      </Typography>
      <Typography variant='body1'>
        <strong style={{color: config().colors.muted}}>Updated At:</strong> {formatDate(lead.date_updated)}
      </Typography>
      <Typography variant='body1'>
        <strong style={{color: config().colors.muted}}>Last Seen at:</strong> {lead.time_last_seen ? formatDate(lead.time_last_seen) : 'Never' }
      </Typography>
    </Stack>
  );
};

export default LeadSummaryInfo;